export const getDynamicTextByKey = (
  key,
  labels,
  isFirstLetterUpperCase = null
) => {
  let constKey = key;
  let errorCode = "";

  //checking for structure of generic error ("something went wrong, error code: xxxx")
  if (key && key.includes(":")) {
    errorCode = key.split(":")[1];
    constKey = key.split(":")[0];
  }
  //checking from space char. (valid key should not contain spaces!)
  //if space is included, than the text was returned from the server instead of its key (mostly happen for form error)
  if (key && key.includes(" ")) {
    return key;
  }

  //return constkey value from state. if isFirstLetterUpperCase===true, make the first letter uppercase.
  return labels[constKey]
    ? labels[constKey].length > 0
      ? isFirstLetterUpperCase
        ? labels[constKey].charAt(0).toUpperCase() + labels[constKey].slice(1)
        : labels[constKey] + errorCode
      : "missing const: " + constKey
    : constKey;
};
